import { CustomerStatus } from './constants';

export const getCustomerStatus = (status) => {

  let filter = CustomerStatus.filter((st) => st.code === status);
  if (filter.length > 0) {
    return filter[0].name
  }
  return "Bình thường"

}

export const toQuery = (obj) => {
  var str = [];
  for (var p in obj)
    if (obj.hasOwnProperty(p)) {
      str.push(encodeURIComponent(p) + "=" + encodeURIComponent(obj[p]));
    }
  return str.join("&");
}

export const isGrantPermission = (allows, permissions) => {
  const granted = allows.filter((per) => permissions.includes(per.code)).length > 0
  return granted;
}

export const numberToVietnameseWords = (num) => {
  const ChuSo = ["không", "một", "hai", "ba", "bốn", "năm", "sáu", "bảy", "tám", "chín"];
  const Tien = ["", "nghìn", "triệu", "tỷ", "nghìn tỷ", "triệu tỷ"];
  
  if (num === 0) return "Không";
  
  let s = "";
  let i = 0;
  while (num > 0) {
      const block = num % 1000;
      if (block !== 0) {
          let str = "";
          const tram = Math.floor(block / 100);
          const chuc = Math.floor((block % 100) / 10);
          const donvi = block % 10;

          if (tram > 0) str += ChuSo[tram] + " trăm ";
          if (chuc > 1) {
              str += ChuSo[chuc] + " mươi ";
              if (donvi === 1) str += "mốt ";
              else if (donvi === 5) str += "lăm ";
              else if (donvi > 0) str += ChuSo[donvi] + " ";
          } else if (chuc === 1) {
              str += "mười ";
              if (donvi > 0) str += ChuSo[donvi] + " ";
          } else if (chuc === 0 && donvi > 0) {
              if (tram > 0) str += "lẻ ";
              str += ChuSo[donvi] + " ";
          }

          s = str.trim() + " " + Tien[i] + " " + s;
      }
      num = Math.floor(num / 1000);
      i++;
  }

  // Chuẩn hóa chuỗi kết quả
  s = s.trim();

  // Viết hoa chữ cái đầu tiên
  return s.charAt(0).toUpperCase() + s.slice(1);
}